import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem } from "@mui/material";
import { useState } from "react";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useUserStore } from "../../../hooks/UseUserStore";

type Values = {
    id: number,
    rut: string,
    name: string,
    first_surname: string,
    second_surname: string,
    gender: string,
    type_person: string,
    idprivilege: number,
    age: string,
    birthdate: string,
    email: string,
    phone: string,
    idcompanies: any,
    iduser_type: number,
    password: string,
    password_confirmation: string,
}

const genders = [
    { id: '0', name: 'Masculino'},
    { id: '1', name: 'Femenino'},
    { id: '2', name: 'Otros'},
]

export const TabGeneralData: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, userSelected, listUser, clearState } = props;

    const { editUser } = useUserStore();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<Values>({
        id: userSelected ? userSelected.id :'',
        rut: userSelected ? userSelected.rut :'',
        name: userSelected ? userSelected.name :'',
        first_surname: userSelected ? userSelected.first_surname :'',
        second_surname: userSelected ? userSelected.second_surname :'',
        gender: userSelected ? userSelected.gender :'',
        type_person: userSelected ? userSelected.type_person :'',
        idprivilege: userSelected ? userSelected.idprivilege :'',
        age: userSelected ? userSelected.age :'',
        birthdate: userSelected ? userSelected.birthdate :'',
        email: userSelected ? userSelected.email :'',
        phone: userSelected ? userSelected.phone :'',
        idcompanies: userSelected ? userSelected.idcompanies :'',
        iduser_type: userSelected ? userSelected.iduser_type :'',
        password: userSelected ? userSelected.password :'',
        password_confirmation: userSelected ? userSelected.password_confirmation :'',
    });

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.first_surname) errors.first_surname = "el campo es requerido";
        if(!values.second_surname) errors.second_surname = "el campo es requerido";
        if(!values.rut) errors.rut = "el campo es requerido";
        if(!values.gender) errors.gender = "el campo es requerido";
        if(!values.iduser_type) errors.iduser_type = "el campo es requerido";
        if(!values.idprivilege) errors.idprivilege = "el campo es requerido";
        if(!values.age) errors.age = "el campo es requerido";
        if(!values.birthdate) errors.birthdate = "el campo es requerido";
        if(!values.email) errors.email = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        if(!values.password && !userSelected) errors.password = "el campo es requerido";
        return errors;
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const onSubmit = async(values)  => {
        setLoading(true);

        const formdata = {
            ...values,
            type_person: '0',
            age: (values.age).toString(),
        }
        const response:any = await editUser(userSelected.id, formdata);
        if(response){
            listUser && listUser();
            closeModal && closeModal();
            clearState && clearState();
            setLoading(false);
        }else{
            setLoading(false);
            return false;
        }
    }

    return (
        <Grid >
            <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container>
                                <Grid item container xs={12} spacing={2}>

                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Nombre completo:</FormLabel>
                                        <TextField
                                        id="name"
                                        type="text" 
                                        name="name"
                                        fullWidth
                                        size="small"
                                        value={values.name}
                                        onChange={handleChange}
                                        error={errors.name && touched.name ? true : false}
                                        helperText={errors.name && touched.name ? errors.name : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Apellido paterno:</FormLabel>
                                        <TextField
                                        id="first_surname"
                                        type="text" 
                                        name="first_surname"
                                        fullWidth
                                        size="small"
                                        value={values.first_surname}
                                        onChange={handleChange}
                                        error={errors.first_surname && touched.first_surname ? true : false}
                                        helperText={errors.first_surname && touched.name ? errors.first_surname : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Apellido materno:</FormLabel>
                                        <TextField
                                        id="second_surname"
                                        type="text" 
                                        name="second_surname"
                                        fullWidth
                                        size="small"
                                        value={values.second_surname}
                                        onChange={handleChange}
                                        error={errors.second_surname && touched.second_surname ? true : false}
                                        helperText={errors.second_surname && touched.second_surname ? errors.second_surname : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Género:</FormLabel>
                                        <Select
                                            id="gender"
                                            value={values.gender}
                                            size="small"
                                            onChange={(event) => { 
                                                setFieldValue("gender", event.target.value);
                                            }}
                                            error={ errors.gender && touched.gender ? true : false }
                                            fullWidth
                                        >
                                            {
                                                genders.map((gender, i) => {
                                                    return <MenuItem key={i} value={gender.id}>{gender.name}</MenuItem>;
                                                })
                                            }
                                        </Select>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Edad:</FormLabel>
                                        <TextField
                                        id="age"
                                        type="number" 
                                        name="age"
                                        fullWidth
                                        size="small"
                                        value={values.age}
                                        onChange={handleChange}
                                        error={errors.age && touched.age ? true : false}
                                        helperText={errors.age && touched.age ? errors.age : ''}
                                        onKeyDown={handleKeyDown}
                                        InputProps={{
                                            inputProps: {
                                                min: 1
                                            }
                                        }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Fecha de nacimiento:</FormLabel>
                                        <TextField
                                        id="birthdate"
                                        type="date" 
                                        name="birthdate"
                                        fullWidth
                                        size="small"
                                        value={values.birthdate}
                                        onChange={handleChange}
                                        error={errors.birthdate && touched.birthdate ? true : false}
                                        helperText={errors.birthdate && touched.birthdate ? errors.birthdate : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Correo:</FormLabel>
                                        <TextField
                                        id="email"
                                        type="email" 
                                        name="email"
                                        fullWidth
                                        size="small"
                                        value={values.email}
                                        onChange={handleChange}
                                        error={errors.email && touched.email ? true : false}
                                        helperText={errors.email && touched.email ? errors.email : ''}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Teléfono:</FormLabel>
                                        <TextField
                                        id="phone"
                                        type="text" 
                                        name="phone"
                                        fullWidth
                                        size="small"
                                        value={values.phone}
                                        onChange={handleChange}
                                        error={errors.phone && touched.phone ? true : false}
                                        helperText={errors.phone && touched.phone ? errors.phone : ''}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Divider />
                            <ModalFooter 
                                buttonType="submit"
                                confirmText={'Guardar'}
                                onConfirm={handleSubmit}
                                cancelText={"Cancelar"}
                                onCancel={closeModal}
                                loadingConfirmText={loading}
                                clearState={clearState}
                            />
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}